import { API_PERMISSIONS } from "./_ApiPermissions";
import { API_BASE } from "./_Connection/_ApiBase";
import { API_SERVICES } from "./_Connection/ApiServices";
import { API_LOAD_ENDPOINTS } from "./ApiEndpoints.js";

export const API_CORE = {

    API_BASE: {
        HAS_CONNECT: API_BASE.HAS_CONNECT,
        URL: API_BASE.API_URL,
        ENDPOINT_BASE: API_BASE.API_ENDPOINT_BASE,
        STATIC: API_BASE.STATIC_URL,
        SOCKET: API_BASE.SOCKET_URL,
        DOCUMENTATION: API_BASE.DOCUMENTATION_URL,
        MODE: API_BASE.BACKEND_MODE,
        VERSION: API_BASE.API_VERSION,
        PORT: API_BASE.API_PORT,
    },

    SERVICES: API_SERVICES,
    PERMISSIONS: API_PERMISSIONS,
    ENDPOINTS: API_LOAD_ENDPOINTS, // Cargamos todas las endpoints para que la API config sepa del endpoint
};